import { MousePointerClick, Sun, Sparkles } from "lucide-react";
import { ASSETS } from "../lib/constants";

const items = [
  {
    icon: MousePointerClick,
    slug: "een-klik",
    title: "Eén klik",
    text: "Schakel glas van transparant naar mat wanneer jij privacy nodig hebt.",
  },
  {
    icon: Sun,
    slug: "licht-blijft-binnen",
    title: "Licht blijft binnen",
    text: "Geniet van privacy zonder je ruimte donker te maken.",
  },
  {
    icon: Sparkles,
    slug: "strakke-look",
    title: "Strakke look",
    text: "Geen gordijnen of jaloezieën nodig. Alleen glas, licht en rust.",
  },
];

export default function WhatIsSmartFilm() {
  return (
    <section
      id="wat-is-smart-film"
      className="relative py-24 md:py-32"
      data-testid="what-is-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-4">
              Kennismaking
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight leading-[1.05]">
              Wat is{" "}
              <span
                className="italic font-medium"
                style={{ color: "#00E5FF" }}
              >
                Privacy Smart Film
              </span>
              ?
            </h2>
            <p className="mt-6 text-base md:text-lg text-zinc-400 font-body leading-relaxed">
              Privacy Smart Film is een slimme folie die op bestaand glas
              wordt aangebracht. Met één klik schakelt het glas van
              transparant naar mat, zodat je direct privacy krijgt zonder
              daglicht te verliezen.
            </p>

            <div className="mt-10 space-y-4">
              {items.map((it) => {
                const Icon = it.icon;
                return (
                  <div
                    key={it.title}
                    className="flex items-start gap-4"
                    data-testid={`smartfilm-card-${it.slug}`}
                  >
                    <div
                      className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 border border-cyan-400/30"
                      style={{ background: "rgba(0,229,255,0.08)" }}
                    >
                      <Icon size={20} className="text-cyan-400" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg md:text-xl text-white font-medium tracking-tight">
                        {it.title}
                      </h3>
                      <p className="mt-1 text-sm md:text-base text-zinc-400 font-body leading-relaxed">
                        {it.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <p className="mt-10 text-xs text-zinc-500 font-body italic">
              Geschiktheid wordt bekeken per project, op basis van type glas,
              afmetingen en toepassing.
            </p>
          </div>

          <div className="lg:col-span-6">
            <div
              className="rounded-3xl overflow-hidden border border-white/10"
              data-testid="smartfilm-context-visual"
            >
              <img
                src={ASSETS.smartFilmContext}
                alt="Privacy Smart Film toegepast in badkamer, kantoor, woning en glaswand"
                className="w-full h-full object-cover"
              />
            </div>
            <p className="mt-3 text-[11px] uppercase tracking-[0.2em] text-zinc-500 text-center">
              Toepassingen: badkamer · kantoor · woning · glaswand
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
